import { Component, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { IPolicy } from 'src/app/@shared/model/policy.model';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import {PolicyService} from "@shared/services/api/policy.service";
import {IMeta, MetaService} from "@shared/services/web/meta.service";
import {BreadcrumbsService} from "@shared/services/web/breadcrumbs.service";
@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss'],
})
export class PrivacyPolicyComponent implements OnInit, OnDestroy {
  private changeLangSubscription: Subscription;
  isLoading: boolean = false;
  policy: IPolicy;
  lang: string;

  constructor(
    public policyService: PolicyService,
    private sanitizer: DomSanitizer,
    private translateService: TranslateService,
    private metaService: MetaService,
    private breadcrumbsService: BreadcrumbsService
  ) {
    this.changeMeta();
    this.setBreadcrumb();
  }

  changeMeta() {
    const meta: IMeta = {
      language: this.translateService.currentLang,
      title: 'politica',
      description: 'politica_desc',
    };
    this.metaService.changeMeta(meta);
  }

  ngOnInit(): void {
    this.lang = this.translateService.currentLang;
    this.isLoading = true;
    this.policyService.getPolicyConditions().subscribe((data) => {
      this.policy = data;
      this.isLoading = false;
    });

    this.changeLangSubscription = this.translateService.onLangChange.subscribe(
      (event: LangChangeEvent) => {
        this.lang = event.lang;
        this.changeMeta();
      }
    );
  }

  ngOnDestroy() {
    if (this.changeLangSubscription) {
      this.changeLangSubscription.unsubscribe();
    }
  }

  transform(policy: IPolicy): any {
    if (this.lang == 'es') {
      return this.sanitizer.bypassSecurityTrustHtml(policy.text);
    } else if (this.lang == 'en') {
      return this.sanitizer.bypassSecurityTrustHtml(policy.text_en);
    }
  }

  setBreadcrumb() {
    this.breadcrumbsService.setBreadcrumb([
      { label: 'Inicio', label_en: 'Home', path: '/' },
      {
        label: 'Política de privacidad',
        label_en: 'Privacy policy',
        path: null,
      },
    ]);
  }
}
